import {getCookie, ErrorBox} from "../lib"


let spinnerCount = 0;

/* function api_client1 (opts) {
  const secret = getCookie("secret");

  let _opts ={    url:"",    pathParam:"0",    queryParam:{} , method:'get', data:[]};
  _opts = {..._opts, opts};
  _opts = Object.assign({}, _opts, opts);  
  _opts.queryParam.api_service = `${process.env.REACT_APP_API_SERVER}/${opts.url}/${_opts.pathParam}` ;
  //_opts.queryParam.secret = secret ;
  let queryString;
  if (opts.queryParam !=={}){
    queryString = Object.keys(_opts.queryParam).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(_opts.queryParam[key])).join('&');
  }
  let href = "";
  href = window.location.href.split('/');
  href = href[href.length-1];
  if (href==='') {
    href = "---"
  }
  let url = "";
  if (queryString !== "" ) {
      url = url + "?" + queryString
  }
  const timestamp = new Date().valueOf()
  url = `${process.env.REACT_APP_API_URL}${url}&timestamp=${timestamp}`;
//  url = `${process.env.REACT_APP_API_URL}/${url}`
  
  let errorOccured = false;
  spinnerCount++;
  document.getElementById("spinner-handler").style.visibility ="visible"
  return fetch(url, {
    method: _opts.method,
//    cache: 'no-cache', 
//    headers: {'access-control-allow-origin':'*', 'authorization': secret,'module-authorization': secret, "module-name": href ,  'Content-Type': 'application/json;charset=utf-8', },
//    headers: {authorization:'','module-authorization': secret, "module-name": href ,  'Content-Type': 'application/json;charset=utf-8' },
//    headers: {'Authorization':secret,'SomeAuthorize': secret },
//    redirect: 'follow',
//    referrer: 'no-referrer',
    headers: {
      'authorization': '',
      'Module-Authorization': secret,
//      'Content-Type': 'application/json;charset=utf-8'
    },
    body: JSON.stringify(opts.data)
  }).then(response => {
    console.log("then response.text");
    if (!response.ok || response.status === 404 ) {
      console.log(response);
      errorOccured = true;
      return response.text()
    } else {
      return response
    }
  }).then(response => {
    resetSpinner();
    if (errorOccured) {
//      ErrorBox(response + ' \n\n' +  _opts.queryParam.api_service)
      throw new Error(response + ' \n\n' +  _opts.queryParam.api_service);
    }
    try {
      console.log("then response.json");
      const data = response.json()
      return data;
    } catch (e){
      ErrorBox(e)
      throw e;
    }
  }).catch(err => {
    console.log("then catch");
    resetSpinner();
    ErrorBox(err)
//    alert(err);
//    err.text().then( errorMessage => {
//      console.log("errorMessage:" ,errorMessage);
//    })      
//    alert(err);
    throw err;
  })
}
 */
function api_client (opts) {
  const secret = getCookie("secret");

  let _opts ={    url:"",    pathParam:"0",    queryParam:{} , method:'get', data:[]};
  _opts = {..._opts, opts};
  _opts = Object.assign({}, _opts, opts);  
  _opts.queryParam.api_service = `${process.env.REACT_APP_API_SERVER}/${opts.url}/${_opts.pathParam}` ;
  //_opts.queryParam.secret = secret ;
  let queryString;
  if (opts.queryParam !=={}){
    queryString = Object.keys(_opts.queryParam).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(_opts.queryParam[key])).join('&');
  }
  let href = "";
  href = window.location.href.split('/');
  href = href[href.length-1];
  if (href==='') {
    href = "---"
  }
  let url = "";
  if (queryString !== "" ) {
      url = url + "?" + queryString
  }
  const timestamp = new Date().valueOf()
  url = `${process.env.REACT_APP_API_URL}${url}&timestamp=${timestamp}`;
//  url = `${process.env.REACT_APP_API_URL}/${url}`
  
  let errorOccured = false;
  spinnerCount++;
  document.getElementById("spinner-handler").style.visibility ="visible"
  let successFn ;
  let errorFn ;
  var conditionBuilder = {
    success : function(resolveFn){
      successFn = resolveFn;
      return conditionBuilder;
    },
    error: function(resolveFn){
      errorFn = resolveFn;
      return conditionBuilder;
    }  
  }
  fetch(url, {
    method: _opts.method,
//    cache: 'no-cache', 
//    headers: {'access-control-allow-origin':'*', 'authorization': secret,'module-authorization': secret, "module-name": href ,  'Content-Type': 'application/json;charset=utf-8', },
//    headers: {authorization:'','module-authorization': secret, "module-name": href ,  'Content-Type': 'application/json;charset=utf-8' },
//    headers: {'Authorization':secret,'SomeAuthorize': secret },
//    redirect: 'follow',
//    referrer: 'no-referrer',
    headers: {
      'authorization': '',
      'Module-Authorization': secret,
//      'Content-Type': 'application/json;charset=utf-8'
    },
    body: JSON.stringify(opts.data)
  }).then(response => {
    if (!response.ok || response.status === 404 ) {
      errorOccured = true;
      return response.text()
    } else {
      return response.text()
    }
  }).then(response => {
    resetSpinner();
    if (errorOccured) {
      ErrorBox(response);
      errorFn(response)
//      errorFn(response);
      return
    }
    try {
      const jsondata = JSON.parse(response);
      successFn(jsondata);
    } catch (e){
      ErrorBox(e + response);
      if (errorFn) {
        errorFn(e);
      }
    }
  }).catch(err => {
    resetSpinner();
    ErrorBox(err ) ;
    if (errorFn) {
      errorFn(err);
    }
  })
  return conditionBuilder;
}

function resetSpinner() {
  spinnerCount--;
  if (spinnerCount<=0){
    spinnerCount=0;
    document.getElementById("spinner-handler").style.visibility ="hidden"
  }
}

function api_get (opts) {
  opts.method="get"
  return api_client(opts);
}

function api_post (opts) {
  opts.method="post"
  return api_client(opts);
}

function api_put (opts) {
  opts.method="put"
  return api_client(opts);
}

function api_delete (opts) {
  opts.method="delete"
  return api_client(opts);
}

function api_report(url,queryParam){
  const secret = getCookie("secret");
  let queryString;
  queryParam.api_service = `${process.env.REACT_APP_API_SERVER}/` + url ;
  queryParam.secret = secret;
  if (queryParam !=={}){
    queryString = Object.keys(queryParam).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(queryParam[key])).join('&');
  }
  const _url= `${process.env.REACT_APP_API_URL}?${queryString}` ;
  return _url;

}
/* function api_client1 (opts) {
  
  let _opts ={    url:"",    pathParam:"0",    queryParam:{} , method:'get', data:[]};
  _opts = {..._opts, opts};
  _opts = Object.assign({}, _opts, opts);  
  var queryString;
  if (opts.queryParam !=={}){
    queryString = Object.keys(_opts.queryParam).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(_opts.queryParam[key])).join('&');
  }
  let href = "";
  href = window.location.href.split('/');
  href = href[href.length-1];
  if (href==='') {
    href = "---"
  }
  
  var url = _opts.url 
  if (_opts.pathParam!=="") {
      url = url + "/" + _opts.pathParam 
  }
  if (queryString !== "" ) {
      url = url + "?" + queryString
  }
  url = `${process.env.REACT_APP_API_URL}/${url}`
  let errorOccured = false;
  const secret = getCookie("secret");
  spinnerCount++;
  document.getElementById("spinner-handler").style.visibility ="visible"
  return fetch(url, {
    method: _opts.method,
    cache: 'no-cache', 
    headers: {authorization: secret, "module-name": href ,  'Content-Type': 'application/json', },
    redirect: 'follow',
    referrer: 'no-referrer',
    body: JSON.stringify(opts.data)
  }).then(response => {
    if (!response.ok) {
      errorOccured = true;
      return response.text()
    } else {
      return response
    }
  }).then(response => {
    if (errorOccured) {
      throw new Error(response);
    }
    const data = response.json()
    spinnerCount--;
    if (spinnerCount===0)
      document.getElementById("spinner-handler").style.visibility ="hidden"
    return data;
  }).catch(err => {
    spinnerCount--;
    if (spinnerCount===0)
      document.getElementById("spinner-handler").style.visibility ="hidden"
    alert(err);
    throw err;
  })
} */


export { api_get, api_post, api_put, api_delete, api_report}